/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme, ThemeOptions } from "@mui/material";

export const typographyStyle = (theme: Theme): ThemeOptions["typography"] => {
  const headlineCommonStyles = {
    fontFamily: "'Roboto', sans-serif",
    fontWeight: 400,
  };

  return {
    fontFamily: "'Inter', sans-serif",
    h1: {
      ...headlineCommonStyles,
      fontSize: theme.typography.pxToRem(54),
      lineHeight: 1.08,
      marginTop: "1.25rem",
      marginBottom: "0.625rem",
      [theme.breakpoints.up("sm")]: {
        fontSize: theme.typography.pxToRem(64),
      },
    },
    h2: {
      ...headlineCommonStyles,
      lineHeight: 1.16,
      fontSize: theme.typography.pxToRem(48),
      marginTop: "1.25rem",
      marginBottom: "0.625rem",
      [theme.breakpoints.up("sm")]: {
        fontSize: theme.typography.pxToRem(52),
      },
    },
    h3: {
      ...headlineCommonStyles,
      fontSize: theme.typography.pxToRem(40),
      lineHeight: 1.16,
      marginTop: "1.25rem",
      marginBottom: "0.625rem",
      [theme.breakpoints.up("sm")]: {
        fontSize: theme.typography.pxToRem(44),
      },
    },
    h4: {
      ...headlineCommonStyles,
      fontSize: theme.typography.pxToRem(32),
      lineHeight: 1.24,
      marginTop: "0.625rem",
      marginBottom: "0.625rem",
      [theme.breakpoints.up("sm")]: {
        fontSize: theme.typography.pxToRem(40),
      },
    },
    h5: {
      ...headlineCommonStyles,
      fontSize: theme.typography.pxToRem(24),
      lineHeight: 1.32,
      marginTop: "0.625rem",
      marginBottom: "0.625rem",
      [theme.breakpoints.up("sm")]: {
        fontSize: theme.typography.pxToRem(32),
        lineHeight: 1.24,
      },
    },
    h6: {
      ...headlineCommonStyles,
      fontSize: theme.typography.pxToRem(18),
      lineHeight: 1.32,
      [theme.breakpoints.up("sm")]: {
        fontSize: theme.typography.pxToRem(24),
      },
    },
    h7: {
      ...headlineCommonStyles,
      fontSize: theme.typography.pxToRem(18),
      lineHeight: 1.56,
      [theme.breakpoints.up("sm")]: {
        fontSize: theme.typography.pxToRem(20),
      },
    },
    formLegend: {
      fontFamily: "'Inter', sans-serif",
      fontSize: theme.typography.pxToRem(18),
      lineHeight: 1.5,
      fontWeight: 400,
      letterSpacing: 0,
      textAlign: "center",
      padding: "0 1rem",
      margin: "0 auto",
      [theme.breakpoints.up("sm")]: {
        fontSize: theme.typography.pxToRem(20),
      },
    },
    body1: {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: 1.56,
      fontWeight: 400,
      [theme.breakpoints.up("sm")]: {
        fontSize: theme.typography.pxToRem(18),
      },
    },
    body2: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: 1.56,
      fontWeight: 400,
      [theme.breakpoints.up("sm")]: {
        fontSize: theme.typography.pxToRem(16),
      },
    },
    body3: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: 1.56,
      fontWeight: 400,
      [theme.breakpoints.up("sm")]: {
        fontSize: theme.typography.pxToRem(14),
      },
    },
    button: {
      fontSize: theme.typography.pxToRem(18),
      lineHeight: 1.2,
      fontWeight: 500,
      textTransform: "none",
    },
  };
};
